// extracted by mini-css-extract-plugin
export var bodySections = "_a3-8";
export var gray = "_a3-7";
export var green = "_a3-4";
export var iconContainer = "_a3-9";
export var iconWidgetContainer = "_a3-1";
export var phoneIcon = "_a3-2";
export var red = "_a3-5";
export var statusDot = "_a3-3";
export var widgetContainer = "_a3-0";
export var yellow = "_a3-6";